import { render, staticRenderFns } from "./RiyGrossReturnChart.vue?vue&type=template&id=5ed1a2be&scoped=true"
import script from "./RiyGrossReturnChart.vue?vue&type=script&lang=js"
export * from "./RiyGrossReturnChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed1a2be",
  null
  
)

export default component.exports